import { render } from "./comp-menu.vue?vue&type=template&id=64e5ee94&ts=true"
import script from "./comp-menu.vue?vue&type=script&lang=ts"
export * from "./comp-menu.vue?vue&type=script&lang=ts"

import "./comp-menu.vue?vue&type=style&index=0&id=64e5ee94&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__